import type { Popup } from 'popups/Popup';
import type { Bounds, Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { AdErrorLayout } from '../../../../layouts/popups/AdErrorLayout';
import { waitForMs } from '../../../utils/async-utils';
import type { PopupStackController } from '../../../popups/PopupStackController';
import type { PopupElementAnimationData } from '../../../popups/PopupAnimations';

export type AdErrorPopupEvent = 'closed';

export class AdErrorPopup implements Popup {
  public readonly root: Container;

  public readonly initialBounds: Bounds;

  private readonly layout: AdErrorLayout;

  public readonly onEvent = new Signal<(event: AdErrorPopupEvent) => void>();

  public static async show(popupStack: PopupStackController): Promise<void> {
    void popupStack.addPopup({
      popupConstructor: AdErrorPopup,
      settings: { overlay: true },
    });
    await waitForMs(2500);
    await popupStack.closeActivePopup();
  }

  constructor() {
    this.layout = new AdErrorLayout();
    this.root = this.layout.root;

    // make bounds bigger so the window doesn't scale huge.
    const bounds = this.root.getLocalBounds();
    bounds.width += 175;
    bounds.height += 140;
    this.initialBounds = bounds;
  }

  public getAnimatedElements(): PopupElementAnimationData[] {
    return [{ container: this.layout.popup }];
  }
}
